import NextLink from 'next/link'
import type { LinkProps } from '.'

const Link: React.FC<LinkProps> = ({ href, children, className, newTab = false, title = '', ...props }) => {
  const anchorProps = {
    className,
    title,
  }

  const click =
    props.onClick ||
    // eslint-disable-next-line func-names
    function () {
      return null
    }

  if (newTab) {
    Object.assign(anchorProps, {
      target: '_blank',
      rel: 'noreferrer',
    })
  }
  return (
    <NextLink href={href} {...props}>
      <a aria-hidden="true" {...anchorProps} onClick={click}>
        {children}
      </a>
    </NextLink>
  )
}

export default Link
